import Keycloak from "keycloak-js";
import keycloakConfig from "../config/keycloakConfig";

const keycloak = new Keycloak(keycloakConfig);

let keycloakInitialized = false;

// export const initKeycloak = () => {
//   return keycloak.init({
//     onLoad: 'check-sso',
//     silentCheckSsoRedirectUri: window.location.origin + '/silent-check-sso.html',
//   });
// };

// export const initKeycloak = () => {
//     return keycloak.init({
//       onLoad: 'check-sso',
//       flow: 'standard',  // Usa il flusso standard invece di implicit
//       redirectUri: window.location.origin  // Assicurati che questo sia corretto
//     });
//   };

export const initKeycloak = async () => {
  if (keycloakInitialized) {
    return;
  }
  try {
    const authenticated = await keycloak.init({
      onLoad: "check-sso",
      flow: "standard",
      silentCheckSsoRedirectUri:
        window.location.origin + "/silent-check-sso.html",
      // Se il browser blocca i cookie di terze parti (es. frontend su Cloudflare,
      // Keycloak su dominio diverso), il silent check fallisce silenziosamente
      // invece di bloccare l'app in attesa indefinita.
      silentCheckSsoFallback: false,
    });
    keycloakInitialized = true;
    return authenticated;
  } catch (error) {
    console.error("Keycloak initialization error:", error);
    throw error;
  }
};

export const login = () => keycloak.login();

export const logout = () => keycloak.logout();

export const getToken = () => keycloak.token;

export const getTokenParsed = () => keycloak.tokenParsed;

export const isLoggedIn = () => !!keycloak.token;

export const updateToken = (minValidity: number) =>
  keycloak.updateToken(minValidity);

export const refreshToken = () => {
  return keycloak.updateToken(5);
};

export const getUsername = (): string => {
  // Implementa la logica per ottenere il nome utente
  // Questo potrebbe provenire dal token JWT, da una chiamata API, o da uno store locale
  // Per esempio, se usi Keycloak:
  return keycloak.tokenParsed?.preferred_username || "Utente";
};
